import { Channel, Topic } from "../../constants";
import { DataUtils, MessageBrokerUtils } from "../../utils";
import React, { useCallback } from "react";

import { EmptyComponent } from "../common/EmptyComponent";
import Loadable from "react-loadable";
import { UserContextSelectors } from "../../redux/selectors";
import { useSelector } from "react-redux";

const MiniCashierOnDemand = Loadable({
  loader: () =>
    import(/* webpackChunkName: "container/minicashier" */ "./MiniCashier"),
  loading: EmptyComponent
});

const isMiniCashierEnabled =
  DataUtils.getDataStoreValue("MiniCashierEnabled") &&
  DataUtils.getDataStoreValue("MiniCashierURL");

export const MiniCashier = props => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  if (!isAuthenticated || !isMiniCashierEnabled) return null;

  return <MiniCashierOnDemand {...props} />;
};

export const useMiniCashierCommunicationHandler = () => {
  const openCashier = useCallback(data => {
    MessageBrokerUtils.publish({
      channel: Channel.PAYMENT,
      topic: Topic.CTA_Cashier_Open,
      headers: {
        publisher: "UAA"
      },
      data: data
    });
  }, []);

  return { openCashier };
};
